import React, { useState } from "react";
import { Container, Typography, Stack, Button } from "@mui/material";
import { containerStyle } from "./MessagesCommon";
import MessageList from "./MessageList";
import ComposeModal from "./ComposeModal";
import { messages } from "../config/messages";
import { USER_ACTIONS, isAllowedAction } from "../config/auth";

export default function MessagesNotification(props) {
  const [composeOpen, setComposeOpen] = useState(false);

  const canRead = isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY);
  // const canWrite = isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY);

  // If the user doesn't have permissions to view logs, don't render anything
  if (!canRead) return null;

  return (
    <Container sx={{ mt: 2, mb: 8 }}>
      <Stack sx={{ mb: 1, mt: 1 }}>
        <div className="background-shape-green text-center">
          <Typography variant="h2" sx={{ mb: 1, mt: 5 }}>
            {messages.messagesBroadcastPage_title}
          </Typography>
        </div>
      </Stack>

      <div style={containerStyle}>
        <div style={{
          padding: "16px 20px",
          borderBottom: "1px solid #e8e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#fff",
          flexShrink: 0,
        }}>
          <div>
            <Typography variant="h6" style={{ fontWeight: 700, color: "#4a5568", margin: 0 }}>
              {messages.broadcastList_title}
            </Typography>
          </div>
        </div>

        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          {/* Hardcoded direction to OUTBOX with no conditional tab switches */}
          <MessageList
            direction="OUTBOX"
            onMessageRead={() => {}}
          />
        </div>
      </div>

      {composeOpen && (
        <ComposeModal
          selectedConnectors={[]} // Defaults to an empty subset context or "ALL" if handling global broadcasts
          onClose={() => setComposeOpen(false)}
          onSent={() => {
            setComposeOpen(false);
            // Forces MessageList component instance reload to pull latest outbox record
            window.location.reload();
          }}
        />
      )}
    </Container>
  );
}
